<script setup lang="ts">
defineOptions({
	name: 'DataSubjectsSection',
})

const { t: $t, locale } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-ic:outline-balance"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Right of Data Subjects') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						'Under the GDPR, Data Subjects have several rights that empower them to exercise greater control over their Personal Data. These rights include',
					)
				}}{{ locale === 'fr' ? ' :' : ':' }}
			</p>

			<ul class="list-disc pl-7 space-y-2.5">
				<li>{{ $t('Right of Access: The right to access their Personal Data') }}.</li>

				<li>
					{{
						$t('Right to Rectification: The right to request corrections to any inaccuracies in their Personal Data')
					}}.
				</li>

				<li>{{ $t('Right to Erasure: The right to have their Personal Data erased in certain circumstances') }}.</li>

				<li>
					{{
						$t('Right to Restriction of Processing: The right to request the restriction of Personal Data Processing')
					}}.
				</li>

				<li>
					{{ $t('Right to Portability: The right to obtain their Personal Data in a portable format for transfer') }}.
				</li>

				<li>{{ $t('Right to Object: The right to object to specific Processing activities') }}.</li>

				<li>
					{{ $t('Right to Lodge a Complaint: The right to lodge a complaint with a Data Protection Authority') }}.
				</li>
			</ul>

			<p>
				{{
					$t(
						'If the processing activity is based on consent, Data Subjects can withdraw their consent at any time (Right to Withdraw Consent). However, this withdrawal will not affect the lawfulness of any processing activities conducted based on consent prior to its withdrawal',
					)
				}}.
			</p>

			<p>
				{{
					$t(
						'To exercise any of these rights, Data Subjects can contact Gaveta Decimal through the following email address: {email}. Responses to such requests will be provided within one month, although this timeframe may be extended in certain situations (e.g., due to the complexity of the request)',
						{
							email: 'hello@lucky-wise.com',
						},
					)
				}}.
			</p>
		</div>
	</section>
</template>
